var exports = {
  "k": "actionItem__0m7tcQ",
  "y": "divider__DAdINR",
};

module.exports = exports;
